import { useTheme } from '@mui/material/styles';
import React from 'react';
import LogoImage from '../assets/logo/TOTAL BAT LOGO VECTOR.png';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showTagline?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  size = 'medium',
  showTagline = true,
  className = ''
}) => {
  const theme = useTheme();
  const sizeMap = {
    small: 120,
    medium: 200,
    large: 280,
  } as const;

  const width = sizeMap[size];

  return (
    <div className={`logo-container ${className}`} style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <img
        src={LogoImage}
        alt="TotalBat"
        style={{
          width,
          height: 'auto',
          display: 'block',
          filter: theme.palette.mode === 'dark' ? 'brightness(0.95) contrast(1.05)' : 'none',
        }}
      />
      {showTagline && (
        <span style={{
          marginTop: 4,
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: 0.5,
          color: theme.palette.text.secondary,
        }}>
          OUTILS, ÉQUIPEMENTS & FOURNITURES
        </span>
      )}
    </div>
  );
};

export default Logo;